import {observe} from 'mobx';
import {useEffect, useState} from 'react';

export default function useObserve(store) {
    const [state, setState] = useState(false);

    useEffect(() => {
        observe(store, change => {
            setState(!state);
        });
    }, [state]);
}